<form [formGroup]="form">
  <div formArrayName="options">
    @for (option of options.controls; track option; let i = $index) {
      <div [formGroupName]="i" class="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
        @if (option.get('state')?.value !== 'delete') {
          <mat-form-field>
            <mat-label>Variation Name</mat-label>
            <input matInput formControlName="addon_name" />
            @if (option.get('addon_name')?.hasError('required')) {
              <mat-error>
                Variation Name is required.
              </mat-error>
            }
            @if (option.get('addon_name')?.hasError('duplicateName')) {
              <mat-error>
                Variation Name must be unique.
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Variation Price</mat-label>
            <input matInput formControlName="price" type="number"
              [placeholder]="isRequestQuote ? 'Not Applicable' : ''" />
            @if (isRequestQuote) {
              <mat-hint class="text-amber-600">Not Applicable</mat-hint>
            }
            @if (!isRequestQuote && option.get('price')?.hasError('required')) {
              <mat-error>Variation Price is required.</mat-error>
            }
            @if (!isRequestQuote && option.get('price')?.hasError('duplicatePrice')) {
              <mat-error>Variation Price must be unique.</mat-error>
            }
          </mat-form-field>
          <!-- The bag / box it ships in; FishyHub sets the matching delivery
               cost from it. Required: No Transhipment by default within the
               supplier country, the merchant's choice for any other. -->
          <mat-form-field>
            <mat-label>Transhipment Packing Size</mat-label>
            <mat-select formControlName="packing_size">
              @for (size of packingSizes; track size.key) {
                <mat-option [value]="size.key">{{ size.label }}</mat-option>
              }
            </mat-select>
            @if (option.get('packing_size')?.hasError('required')) {
              <mat-error>Choose a Transhipment Packing Size.</mat-error>
            }
          </mat-form-field>
          @if (options.length > 1) {
            <button mat-icon-button (click)="removeOption(i)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        }
      </div>
    }
  </div>
  <button mat-flat-button (click)="addOption()">
    <mat-icon>add</mat-icon> Add Option
  </button>

</form>
